module.exports = __webpack_public_path__ + "media/MRI21B.d0de45ab.mp3";